module.exports = __webpack_public_path__ + "static/media/3.1a5c1687.svg";